export default __webpack_public_path__ + "static/media/tick.eda8002b.PNG";